// extracted by mini-css-extract-plugin
export default {"selectLanguageOnDark":"LanguageDropdown_selectLanguageOnDark__JAQ9A"};